<template>
  <div>
    <v-tabs
      dark
      color="primary"
      slot="extension"
      v-model="tab"
      align-with-title
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab>Proceso</v-tab>
      <v-tab>Pesadas</v-tab>
      <v-tab>Incidencias</v-tab>
      <v-tab v-if="hasAnalysis">Analíticas</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" @change="submit">
      <v-tab-item>
          <process-form
          title=""
          :is-valid.sync="valid"
          :process.sync="process"
          :masters.sync="masters"
          :errors="fieldErrors"
          :loading="loading"
          @submit="submit"
          action-name="Guardar"
          ref="processForm"
        />
      </v-tab-item>
      <v-tab-item>
        <v-sheet class="pa-3">
          <weighing-form :weighing.sync="weighing" v-for="weighing in process.weighings" :key="weighing.id" />
        </v-sheet>
      </v-tab-item>
      <v-tab-item>
        <data-table
          :items="process.incidents"
          :headers="headers"
          :loading="loading"
          :row-action="toDetailRoute"
          :hide-actions="true"
        >
          <template slot="row" slot-scope="row" >
            <td>{{ row.item.code }}</td>
            <td>{{ row.item.description }}</td>
            <td>{{ row.item.operator }}</td>
            <td>
              {{ row.item.duration }}
              <span v-if="row.item.duration"> m.</span>
            </td>
            <td>{{ row.item.severity_display }}</td>
            <td>{{ row.item.status_display }}</td>
            <td>
              <v-chip :color="row.item.priority_color_name" text-color="white">
                {{ row.item.priority }}
              </v-chip>
            </td>
            <td>
              <template v-if="row.item.machine">
                  {{ row.item.machine.name }}
              </template>
              <template v-else>---</template>
            </td>
            <td>{{ row.item.created|format-date-time }}</td>
            <td>{{ row.item.modified|format-date-time }}</td>
          </template>
        </data-table>
        <incident-modal
          :process="process"
          :masters="mastersIncidents"
        />
      </v-tab-item>
      <v-tab-item v-if="hasAnalysis">
        <v-sheet class="pa-3">
          <analysis-form :analysisList.sync="process.analysis" />
        </v-sheet>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import api from '@/api/app'
import DataTable from '@/components/DataTable'
import formMixin from '@/mixins/formMixin'
import IncidentModal from '@/partials/IncidentModal'
import mutationsMixin from '@/mixins/mutationsMixin'
import ProcessForm from '@/partials/ProcessForm'
import WeighingForm from '@/partials/WeighingForm'
import AnalysisForm from '@/partials/AnalysisForm'

export default {
  name: 'process',
  components: {DataTable, IncidentModal, ProcessForm, WeighingForm, AnalysisForm},
  mixins: [formMixin, mutationsMixin],
  created () {
    this.loading = true
    let p1 = api.getProcessTypes().then(response => {
      this.masters.processTypes = response
    })

    let p2 = api.getProcessStatuses().then(response => {
      this.masters.statuses = response
    })

    let p3 = api.getTags().then(response => {
      this.masters.tags = response
    })

    if (this.process.process_type) {
      this.loadProcessTypeMaterials()
    }

    Promise.all([p1, p2, p3]).then(() => {
      this.loading = false
    })
  },
  mounted () {
    this.loadProcess()

    this.loading = true
    let p1 = api.getIncidentStatuses().then(response => {
      this.mastersIncidents.statuses = response
    })

    let p2 = api.getSeverities().then(response => {
      this.mastersIncidents.severities = response
    })

    let p3 = api.getMachines().then(response => {
      this.mastersIncidents.machines = response
    })

    Promise.all([p1, p2, p3]).then(() => {
      this.loading = false
    })
  },
  data () {
    return {
      tab: null,
      masters: {},
      mastersIncidents: {},
      process: {},
      hasAnalysis: null,
      headers: [
        {
          text: 'Código',
          align: 'left',
          sortable: true,
          value: 'code'
        },
        {
          text: 'Descripción',
          align: 'left',
          sortable: true,
          value: 'description'
        },
        {
          text: 'Operador',
          align: 'left',
          sortable: true,
          value: 'operator'
        },
        {
          text: 'Duración',
          align: 'left',
          sortable: true,
          value: 'duration'
        },
        {
          text: 'Criticidad',
          align: 'left',
          sortable: true,
          value: 'severity'
        },
        {
          text: 'Estado',
          align: 'left',
          sortable: true,
          value: 'status'
        },
        {
          text: 'Prioridad',
          align: 'left',
          sortable: true,
          value: 'priority'
        },
        {
          text: 'Máquina',
          align: 'left',
          sortable: true,
          value: 'machine'
        },
        {
          text: 'Creado',
          align: 'left',
          sortable: true,
          value: 'created'
        },
        {
          text: 'Modificado',
          align: 'left',
          sortable: true,
          value: 'modified'
        }
      ]
    }
  },
  methods: {
    loadProcess () {
      this.loading = true
      let p1 = api.getProcess(this.$route.params.id).then(response => {
        this.process = response
        this.hasAnalysis = this.process.analysis.length
        this.$refs.processForm.loadProcessTypeMaterials(this.process.process_type)
        this.$store.state.pageTitle = 'Procesos | ' + this.process.code
      })
      Promise.all([p1]).then(() => {
        this.$store.commit('setProcessTotalWeight', this.process.total_weight)
        this.loading = false
      })
    },
    toDetailRoute (id) {
      this.$router.push({name: 'incident-detail', params: {'id': id}})
    },
    onSubmit () {
      this.loading = true
      let data = {
        worker_schedule_hours: this.process.worker_schedule_hours || null,
        break_time: this.process.break_time || null,
        start: this.$options.filters.joinDateTime(this.process.startDate, this.process.startTime),
        end: this.$options.filters.joinDateTime(this.process.endDate, this.process.endTime),
        status: this.process.status,
        comments: this.process.comments,
        tags: this.process.tags,
        process_type: this.process.process_type || null,
        material: this.process.material || null
      }
      return api.editProcess(this.process.id, data).then(response => {
        this.process = response
        this.loading = false
      })
    },
    onSuccess () {
      this.success('Proceso actualizado con éxito')
    }
  },
  watch: {
    tab () {
      this.fieldErrors = {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Process.vue